// extracted by mini-css-extract-plugin
module.exports = {"alertError":"login_alertError__3NhE9","loading":"login_loading__2J6wy","homeLogo":"login_homeLogo__qCmWK"};